import { CommunicationsClient } from './resource-clients/communications';
import { TasksClient } from './resource-clients/tasks';
import { TaskTemplatesClient } from './resource-clients/task-templates';
import { CustomersClient } from './resource-clients/customers';
import { AppraiserInstructionsClient } from './resource-clients/appraiser-instructions';
import { ScriptAutomationsClient } from './resource-clients/script-automations';
import { TextSnippetsClient } from './resource-clients/text-snippets';
import { FeaturesClient } from './resource-clients/features';
import { ConstructionIndicesClient } from './resource-clients/construction-indices';
import { MarketAnalysisClient } from './resource-clients/market-analysis';
import { MarketDataClient } from './resource-clients/market-data';
import { AiClient } from './resource-clients/ai';
import { AppraisingEntitiesClient } from './resource-clients/appraising-entity';
import { AssetsClient } from './resource-clients/assets';
import { AssetOverviewsClient } from './resource-clients/asset-overviews';
import { ApiHttpClient } from './resource-clients/http/http-client';
import { OrderNotesClient } from './resource-clients/order-notes';
import { OrderOverviewsClient } from './resource-clients/order-overviews';
import { OrdersClient } from './resource-clients/orders';
import { PlausibilityClient } from './resource-clients/plausibility';
import { ValueChecksClient } from './resource-clients/value-checks';
import { PortfoliosClient } from './resource-clients/portfolios';
import { ValuationsClient } from './resource-clients/valuations';
import { UsersClient } from './resource-clients/users';
import { ReportCustomizationsClient } from './resource-clients/report-customizations';
import { ReferencesClient } from './resource-clients/references';
export class ValuationApiClient {
    marketAnalysis;
    constructionIndices;
    marketData;
    http;
    communications;
    orderNotes;
    orderOverviews;
    tasks;
    taskTemplates;
    features;
    textSnippets;
    scriptAutomations;
    appraiserInstructions;
    customers;
    orders;
    plausibility;
    appraisingEntities;
    valueChecks;
    portfolios;
    valuations;
    assets;
    assetOverviews;
    users;
    ai;
    reportCustomizations;
    references;
    constructor(config) {
        this.http = new ApiHttpClient(config);
        this.communications = new CommunicationsClient(this.http);
        this.orderNotes = new OrderNotesClient(this.http);
        this.orderOverviews = new OrderOverviewsClient(this.http);
        this.tasks = new TasksClient(this.http);
        this.taskTemplates = new TaskTemplatesClient(this.http);
        this.customers = new CustomersClient(this.http);
        this.appraiserInstructions = new AppraiserInstructionsClient(this.http);
        this.scriptAutomations = new ScriptAutomationsClient(this.http);
        this.textSnippets = new TextSnippetsClient(this.http);
        this.features = new FeaturesClient(this.http);
        this.marketAnalysis = new MarketAnalysisClient(this.http);
        this.constructionIndices = new ConstructionIndicesClient(this.http);
        this.marketData = new MarketDataClient(this.http);
        this.orders = new OrdersClient(this.http);
        this.plausibility = new PlausibilityClient(this.http);
        this.appraisingEntities = new AppraisingEntitiesClient(this.http);
        this.valueChecks = new ValueChecksClient(this.http);
        this.portfolios = new PortfoliosClient(this.http);
        this.valuations = new ValuationsClient(this.http);
        this.assets = new AssetsClient(this.http);
        this.assetOverviews = new AssetOverviewsClient(this.http);
        this.users = new UsersClient(this.http);
        this.ai = new AiClient(this.http);
        this.reportCustomizations = new ReportCustomizationsClient(this.http);
        this.references = new ReferencesClient(this.http);
    }
}
